import { Drawer, Button } from '@mui/material';

function OptionDialog({ open, onClose = () => {}, onDeleteClick }) {
  return (
    <Drawer
      open={open}
      anchor="bottom"
      onClose={(reason: any) => {
        if (reason === 'backdropClick') return;
        onClose();
      }}
      PaperProps={{ sx: { borderRadius: '10px 10px 0 0' } }}
    >
      <div className="relative w-full p-6 min-h-[100px] text-[#1C1C1C] text-[20px] font-[700] font-['Pretendard'] flex flex-col gap-[14px] items-center justify-between bg-white overflow-hidden">
        <Button
          variant="outlined"
          fullWidth
          sx={{
            color: '#fff',
            bgcolor: '#FF3E3E',
            height: '56px',
            '&:hover': { color: '#fff', bgcolor: '#FF3E3E' },
          }}
          onClick={() => {
            onDeleteClick();
          }}
        >
          <span className="text-[18px]">삭제하기</span>
        </Button>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{ color: '#969696', mt: '12px', fontSize: '18px', '&:hover': { color: '#969696' } }}
          fullWidth
        >
          닫기
        </Button>
      </div>
    </Drawer>
  );
}

export default OptionDialog;
